const defaultTherapistClientFormState = {
  email: "",
  stateId: "",
  countryAlpha2: "",
  locality: "",
  apartment: "",
  address: "",
  name: "",
  countryId: "",
  postal: "",
  deliveryMethod: "",
  voucher: "",
  plan_id: "",
  headset_purchase_token: "",
  headsetType: "regular",
  phoneNumber: null,
  itemType: "Plan",
  token: "",
};

const therapistClientPaymentFields = [
  "email",
  "stateId",
  "countryAlpha2",
  "locality",
  "apartment",
  "address",
  "name",
  "countryId",
  "headsetType",
  "postal",
  "deliveryMethod",
  "voucher",
  "plan_id",
  "headset_purchase_token",
  "user_id",
  "phoneNumber",
  "itemType",
  "token",
];

export { defaultTherapistClientFormState, therapistClientPaymentFields };
